import { post } from '@/backend/api'
import { isErrorResponse, parseError, type ParsedError } from '@/backend/error'
import type { AxiosResponse } from 'axios'

export const startPlanChange = async (
  teamSlug: string,
  planId: string,
): Promise<AxiosResponse | ParsedError> => {
  try {
    const response = await post<{ url: string }>(`/teams/${teamSlug}/billing/plans/start_change`, {
      plan_id: planId,
    })
    return response
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }

    return parseError(error)
  }
}
